<div id="catalog">
    <div class="entries">
        <!-- Filled by js -->
     </div>
</div>